import { GetServerSideProps } from 'next/types';

import Layout from '@/components/layout/LayoutWrapper';
import FamilyTermsMDX from '@/markdown/terms/family-terms.mdx';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const FamilyPlanTerms = () => {
	return (
		<Layout pageName="family-terms" title="Calm - Family Terms">
			<FamilyTermsMDX />
		</Layout>
	);
};

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(context);

	return {
		props: {
			initialState,
			hideAcceptCookiesModal: true,
		},
	};
};

export default FamilyPlanTerms;
